import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { useCallback, useEffect, useMemo, useState } from "react";
import { GameStatus } from "redux-store/slices/game/game.interfaces";

export const useGameTimer = () => {
  const dispatch = useDispatch();

  const status = useSelector(selectors.getGameStatus);
  const isTimerFrozen = useSelector(selectors.getIsTimerFrozen);

  const remainingSeconds = useSelector(selectors.getRemainingTime);
  const [timerRef, setTimerRef] = useState(null);

  const formattedTimeLeft = useMemo(() => {
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;

    const formattedMinutes = minutes.toFixed(0).padStart(2, "0");
    const formattedSeconds = seconds.toFixed(0).padStart(2, "0");

    return `${formattedMinutes}:${formattedSeconds}`;
  }, [remainingSeconds]);

  const updateTime = useCallback(() => {
    if (!isTimerFrozen) {
      dispatch(actions.decrementTimer());
    }
  }, [isTimerFrozen, dispatch]);

  useEffect(() => {
    if (status === GameStatus.PLAYING && !timerRef) {
      const timerIdentifier = setInterval(() => {
        updateTime();
      }, 1000);

      setTimerRef(timerIdentifier);
    }

    return () => {
      if (timerRef) {
        clearInterval(timerRef);
        setTimerRef(null);
      }
    };
  }, [status, timerRef, isTimerFrozen, updateTime]);

  useEffect(() => {
    if (remainingSeconds <= 0 && status === GameStatus.PLAYING) {
      dispatch(actions.setGameStatus(GameStatus.FAIL));
      dispatch(actions.playSound("gameOverAudioId"));
      clearInterval(timerRef);
      setTimerRef(null);
    }
  }, [remainingSeconds, timerRef, dispatch]);

  return { formattedTimeLeft };
};
